module.exports = __webpack_public_path__ + "media/images/Vector-16015b7c57f86a7b4e1ca58bd77d9032.png";